const variablesconstcalls = () => ({
  stateDayNight: {
    sea: {
      backgroundColorDay00: { background: 'linear-gradient(180deg, rgba(100,175,203,1) 16%, rgba(83,144,196,1) 47%, rgba(46,95,120,1) 92%)' },
      backgroundColorNight00: { background: 'linear-gradient(180deg, rgb(59, 158, 175) 16%, rgb(66, 110, 148) 47%, rgb(30, 60, 75) 92%)' },
    }
  },

})

export default variablesconstcalls;